import request from '@/utils/request'

/**
 * 查询缴费明细
 * @param {Object} params 查询参数
 * @returns {Promise} 
 */
export function queryPayFeeDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportFeeMonthStatistics/queryPayFeeDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve({
        data: res.data,
        total: res.total,
        records: res.records,
        sumTotal: res.sumTotal || {}
      })
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 导出缴费明细数据
 * @param {Object} params 导出参数
 * @returns {Promise}
 */
export function exportData(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询费用项列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listFeeConfigs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeConfig.listFeeConfigs',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve({
        feeConfigs: res.feeConfigs || []
      })
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询预约商品订单(禾悦甄选/服务预约)
 * 数据口径与小程序收银台聚合接口 fee.queryCashierPayDetail 中
 * businessType=reserveGoods 一致,落库表 reserve_goods_order
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listReserveGoodsOrderForPayDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reserveOrder.listReserveGoodsOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve({
        data: res.data || [],
        total: res.total || 0,
        records: res.records || 0
      })
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询场地预约订单
 * 数据口径与小程序收银台聚合接口 fee.queryCashierPayDetail 中
 * businessType=venueReservation 一致,落库表 community_space_person
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listCommunitySpacePersonForPayDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communitySpace.listCommunitySpacePerson',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      // 该接口成功时直接返回数组,失败时返回 {code,msg}
      if (Array.isArray(res)) {
        resolve({
          data: res,
          total: res.length,
          records: 1
        })
        return
      }
      resolve({
        data: res.data || [],
        total: res.total || 0,
        records: res.records || 0
      })
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询小区列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listMyEnteredCommunitys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.listMyEnteredCommunitys',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve({
        communitys: res.communitys || []
      })
    }).catch(error => {
      reject(error)
    })
  })
}